import type { QueryClient } from "@tanstack/react-query";

/**
 * #1111: the query key of a tenant's Allowed notification domains, apart from its hook so the
 * rules saves can refresh it without importing that hook (which imports theirs).
 */
export function notificationDomainsPath(tenantId: string): string {
  return `/api/v2/tenants/${tenantId}/notification-domains`;
}

/**
 * A rules save can fix (or add) a saved address outside the list, so the card's count of them
 * ("Saved addresses outside the list") is read again, whichever tenant it is cached for.
 */
export function invalidateNotificationDomains(client: QueryClient): void {
  void client.invalidateQueries({
    predicate: (query) => {
      const head = query.queryKey[0];
      return (
        typeof head === "string" &&
        head.startsWith("/api/v2/tenants/") &&
        head.endsWith("/notification-domains")
      );
    },
  });
}
